export default __webpack_public_path__ + "static/media/foto 3x4 jersu.a2acb416.jpeg";